import { ModelBase } from 'store/model-base';

export class CmsTravelRates extends ModelBase {
    public static storeName: string = 'cmsTravelRates';

    public backToBreadCrumb: CmsBackToBreadCrumb;
    public header: string;
    public paragraph: string;
    public searchLabel: string;
    public searchPlaceholder: string;
    public noCoverageHeader: string;
    public noCoverageDescription: string;
    public gtpCardHeader: string;
    public gtpCardInitialState: string;
    public gtpEligibleText: string;
    public gtpIneligibleText: string;
    public getGtpText: string;
    public payAsGoCardHeader: string;
    public payAsGoCardInitialState: string;
    public payAsGoCardResultState: string;
    public gtpRateDetails: CmsInternationalDetailsDescription[];
    public payAsGoRateDetails: CmsInternationalDetailsDescription[];
    public primaryBtn: string;
    public eligibleIcon: CmsMediaImage;
    public inEligibleIcon: CmsMediaImage;
    public gtpCardDescription: string;
    public payAsGoCardDescription: string;
    public notFoundIcon: CmsMediaImage;
    public notFoundDisclaimer: string;
    public callRatesReaderText: string;
    public gtpUnavailableText: string;
}
